import { EndConsultationContainer } from '../containers/EndConsultationContainer/index'

export const EndConsultationPage = () => (
    <EndConsultationContainer />
)